import { render, staticRenderFns } from "./role.vue?vue&type=template&id=6d631b7a&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=6d631b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d631b7a",
  null
  
)

export default component.exports